export default "__VITE_ASSET__06af6c04__"